// extracted by mini-css-extract-plugin
export default {"parent-mode":"select_parent-mode__Kk19r","inputWrapper":"select_inputWrapper__14363","label":"select_label__m4eba","select":"select_select__Itw+w"};